import Localization from "./main/trans";
import 'regenerator-runtime/runtime';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

window._ = require('lodash');
window.moment = require('moment-timezone');
window.Uppy = require('@uppy/core').default;
window.AwsS3 = require('@uppy/aws-s3').default;

if (typeof(Regulator) !== 'undefined' && typeof(Regulator.user) !== 'undefined') {
    moment.locale(Regulator.user.default_language)
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // window.$ = window.jQuery = require('jquery');
    //
    // require('bootstrap-sass');
    //
    // require('fastclick');
    //
    // require('es6-promise');
    //
    // require('jquery-migrate');
    //
    // require('excanvas.js');

    window.collect = require('collect.js');

    /****************
     * Vue.js Stuff *
     ****************/

    window.Vue = require('vue').default;

    window.Vue.config.devtools = true;

    window.Vue.config.productionTip = false;

    window.Vue2Filters = require('vue2-filters');

    Vue.prototype.$eventHub = new Vue();

    Vue.use(require('vue-resource'));

    Vue.use(Localization);

    /****************
     * Other Stuff *
     ****************/

    window.ResizeSensor = require('css-element-queries/src/ResizeSensor');

    window.ElementQueries = require('css-element-queries/src/ElementQueries');

    window.ElementQueries.listen();

} catch (e) {
}
